/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_App_BuiltinInputs */

const en_why_listening_app_builtin = /** @type {(inputs: Why_Listening_App_BuiltinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built-in reader`)
};

const es_why_listening_app_builtin = /** @type {(inputs: Why_Listening_App_BuiltinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lector integrado`)
};

/**
* | output |
* | --- |
* | "Built-in reader" |
*
* @param {Why_Listening_App_BuiltinInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_app_builtin = /** @type {((inputs?: Why_Listening_App_BuiltinInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_App_BuiltinInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_app_builtin(inputs)
	return en_why_listening_app_builtin(inputs)
});